import {useEffect, useRef, useState} from 'react';
import { jsxActions as cocTestFormActions} from '../../../actions/CoC/cocTestFormActions.js';
import useRedux from 'infrastructure/js/hooks/useRedux';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import useNavBarUpdate from 'infrastructure/js/hooks/useNavBarUpdate';
import {navigationStates} from '../../../enums/navigationStates';
import {jsxActions as messageDialogActions} from '../../../actions/MessageDialog/messageDialogActions';

import CocTestForm from './cocTestForm';
import {isLotAccessible} from '../../../utils/assetHelper';
import {enumTypes, getEnumLabel} from '../../../utils/enumHelper';
import useLabels from 'infrastructure/js/hooks/useLabels';

const getState = (state) => {
  return {
    loading: state.coc.getIn(['cocTestForm', 'loading']),
  }
}

const allActions = {
  cocTestFormActions: cocTestFormActions,
  messageDialogActions: messageDialogActions,
};


function CocTestFormWrapper (props) {
  const { state, actions } = useRedux(allActions, getState);
  const { loading } = state;

  const [initialized, setInitialized] = useState(false);
  const [item, setItem] = useState(null);
  const isFirstRender = useRef(true);

  const labels = useLabels('mat.views.coc.title.');

  const updateNavBar = useNavBarUpdate();

  useEffect(() => {
    const cocTestId = props.match.params.cocTestId;
    const cocId = props.match.params.cocId;
    if (cocTestId && cocId) {
      actions.cocTestFormActions.fetchFormItem(+cocTestId, +cocId).then(data => {
        if (data) {
          setItem(data);
        }
        setInitialized(true);
      })
    }
    else {
      setInitialized(true);
    }

    return () => {
      setInitialized(false);
      actions.cocTestFormActions.clearFormData();
    }
  }, [props.match.params.cocTestId, props.match.params.cocId]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const cocTestId = props.match.params.cocTestId;
    const cocId = props.match.params.cocId;
    if (cocTestId && cocId) {
      actions.cocTestFormActions.fetchFormItem(+cocTestId, +cocId).then(data => {
        if (data) {
          setItem(data);
        }
      });
    }
  }, [props.location?.search]);

  useEffect(() => {
    if (!item?.cocTestData) {
      return;
    }
    const { lotStatus, lotName, qplName, qplVersion } = item.cocTestData;
    const status = isLotAccessible(lotStatus) ? '' : getEnumLabel(enumTypes.LOT_STATUS)(lotStatus);
    updateNavBar(navigationStates.COC, `${labels.get('lot')} ${lotName ?? ''} - ${labels.get('coc')} ${qplName ?? ''}`,
      qplVersion ?? '', -1, status);
  }, [updateNavBar, item, labels]);


  return  initialized ?

    <CocTestForm initialData={item}
             actions={actions}
             loading={loading}
             {...props } /> :
    <Overlay.Loading />
}

export default CocTestFormWrapper;
